import React from 'react'
import styles from 'components/answers/url-post.module.scss'
import cn from 'classnames'
import WithSelection from 'components/shared/WithSelection'
import { isBlockedExternalNavigation } from 'lib/externalNavigationPolicy'
import {
    BLOCKED_EXTERNAL_NAVIGATION_CLASS,
    BLOCKED_EXTERNAL_NAVIGATION_TOAST,
} from 'components/shared/tiptap/blockedExternalNavigation'
import toast from 'utils/toast'
import { safeHttpHref } from 'lib/safeHttpHref'
import 'components/shared/blocked-external-navigation.scss'

export default class UrlPost extends React.Component {
    constructor(props) {
        super(props)
    }

    capture = ev => {
        ev.stopPropagation()
    }

    address = () => {
        const address = this.props.url.address
        const params =
            this.props.domain === 'youtube.com' && this.props.vidStart
                ? `&t=${this.props.vidStart}`
                : ''
        const snippet = encodeURIComponent(this.props.snippet)
        const scrollToText = '' //this.props.snippet ? `#:~:text=${snippet.toLocaleLowerCase()}` : ''
        return `${address}${params}${scrollToText}`
    }

    renderNavigation = children => {
        const address = this.address()
        if (isBlockedExternalNavigation(address)) {
            return (
                <button
                    type="button"
                    className={BLOCKED_EXTERNAL_NAVIGATION_CLASS}
                    title="Blocked suspected scam link"
                    onClick={event => {
                        event.preventDefault()
                        event.stopPropagation()
                        toast.error(BLOCKED_EXTERNAL_NAVIGATION_TOAST, {
                            kind: 'blocked-scam-link',
                            testId: 'blocked-scam-link-toast',
                        })
                    }}
                >
                    {children}
                </button>
            )
        }

        return (
            <a target="_blank" rel="noopener noreferrer" href={safeHttpHref(address)}>
                {children}
            </a>
        )
    }

    render() {
        const url = this.props.url

        return (
            <div className={styles.urlPostComp}>
                <div className={styles.urlTitleContainer}>
                    {url.title && (
                        <WithSelection>
                            <div className={styles.urlTitle} onClick={this.capture}>
                                {this.renderNavigation(
                                    url.title.replace('&nbsp;', ' ').replace('&amp', '&'),
                                )}
                            </div>
                        </WithSelection>
                    )}
                </div>

                <div className={styles.urlAddressContainer}>
                    <WithSelection>
                        <div
                            className={cn(styles.urlAddress, 'url-address fs-mask')}
                            onClick={this.capture}
                        >
                            {this.renderNavigation(this.address())}
                        </div>
                    </WithSelection>
                </div>
            </div>
        )
    }
}
